export const blockIconsSocialEmojiObjectsNew = (
	<span className='material-symbols-outlined'>emoji_objects</span>
);
